import { MDBDataTable } from "mdbreact";
import { useTranslation } from "react-i18next";

const VoucherValue = ({ voucherData }) => {

    const { t } = useTranslation();

    let data = {
        columns: [
            {
                label: t("Voucher Value"),
                field: "voucherValue",
                sort: "asc"
            },
            {
                label: t("Used"),
                field: "used",
                sort: "asc"
            },
            {
                label: t("Available"),
                field: "available",
                sort: "asc"
            },
            {
                label: t("Expired"),
                field: "expired",
                sort: "asc"
            }
        ],
        rows: voucherData
    };

    // let vouchers = [];
    // for (let i = 0; i < voucherData.length; i++) {
    //     if (!vouchers.includes(voucherData[i].voucherAmount)) {
    //         vouchers.push(voucherData[i].voucherAmount);
    //     }
    // }

    // for (let i = 0; i < vouchers.length; i++) {
    //     const dataObject = {
    //         voucherValue: vouchers[i],
    //         used: voucherData.filter(voucher => voucher.voucherAmount === vouchers[i] && voucher.available === "Used").length,
    //         available: voucherData.filter(voucher => voucher.voucherAmount === vouchers[i] && voucher.available === "Available").length,
    //         expired: voucherData.filter(voucher => voucher.voucherAmount === vouchers[i] && voucher.available === "Expired").length,
    //     }
    //     data.rows.push(dataObject);
    // }

    return (<MDBDataTable data={data} noBottomColumns striped hover responsive bordered />);
}

export default VoucherValue;